var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more-horizotnal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.75 5C8.57843 5 9.25 4.32843 9.25 3.5C9.25 2.67157 8.57843 2 7.75 2C6.92157 2 6.25 2.67157 6.25 3.5C6.25 4.32843 6.92157 5 7.75 5Z",
    fill: "#6A82D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13 5C13.8284 5 14.5 4.32843 14.5 3.5C14.5 2.67157 13.8284 2 13 2C12.1716 2 11.5 2.67157 11.5 3.5C11.5 4.32843 12.1716 5 13 5Z",
    fill: "#6A82D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.5 5C3.32843 5 4 4.32843 4 3.5C4 2.67157 3.32843 2 2.5 2C1.67157 2 1 2.67157 1 3.5C1 4.32843 1.67157 5 2.5 5Z",
    fill: "#454C58"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotIcon);
export default __webpack_public_path__ + "static/media/three-dot-icon.c04aa65320a456f7d18aa5e8af938c1e.svg";
export { ForwardRef as ReactComponent };